import React from 'react';
import { useTranslation } from 'react-i18next';
import MulherCurriculo from '../../assets/img/cadastro/mulher-curriculo.png';

const BudgetModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation('budget'); // Usando o namespace 'budget'

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Imagem de fundo - Agora ficará atrás */}
                <div className="modal-background"></div>

                {/* Formulário - Agora ficará acima do fundo */}
                <div className="modal-form-container">
                    <h2>{t('title')}</h2>
                    <p>{t('description')}</p>

                    <form>
                        <input type="text" placeholder={t('company_name')} required />
                        <input type="text" placeholder={t('representative_name')} required />
                        <input type="email" placeholder={t('email')} required />
                        <input type="text" placeholder={t('phone')} required />
                        <textarea placeholder={t('description_placeholder')} required></textarea>
                        <button type="submit">{t('submit')}</button>
                    </form>
                </div>

                {/* Imagem da mulher segurando currículo */}
                <div className="modal-image-right">
                    <img src={MulherCurriculo} alt="Mulher segurando orçamento" />
                </div>
            </div>
        </div>
    );
};

export default BudgetModal;
